import React from "react";

import BaseModule from "../Base";
import podcastImage from './resources/images/podcast_banner.png'
import podcastSound from './resources/podcast.mp3';

export const ProcessModule = () => {

    return <BaseModule
        podcastImage={podcastImage}
        podcastSound={podcastSound}
    />;
};
export default ProcessModule;
